'use strict';

const { captureMessage } = require('../../analytics/sentry');

$(document.body).on('click', '.js-short-link', function (event) {
  var $this = $(this);
  var currentWebsite = $('#dashboard-site > h1 > a').data('url');
  var baseUrl = window.baseUrl || '/' + window.wooGlobal.language + '/';
  var shortUrl = baseUrl + 'report/shorturl';

  event.preventDefault();

  if (!$this.hasClass('load')) {
    $this.addClass('load').fadeTo(100, 0.5);
    return $.ajax({
      type: 'POST',
      data: 'url=' + currentWebsite,
      cache: false,
      url: shortUrl,
      dataType: 'html',
      context: $(this).parent('.js-short-url'),
      success: function (result) {
        var $this = $(this);
        var wooPre = $this.find('pre').removeClass('hidden');
        var trimmedResult = $.trim(result);

        $this.find('.js-short-link').remove();
        return wooPre.html(
          trimmedResult.replace('http://', '<span>http://</span>')
        ).trigger('click');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        captureMessage('Review dashboard short URL error', {
          extra: {
            textStatus: textStatus,
            errorThrown: errorThrown,
            currentWebsite: currentWebsite
          }
        });

        return $('#generic-error-modal').modal('show');
      }
    });
  }
});
